import React, { useEffect, useState } from 'react'
import reactDom from 'react-dom';
import { GetKey } from '../../Actions/GetContainer';
import request from '../../../../Helpers/API';
import { GetMonthNameByNumber } from '../../Helper/GetMonthNameByNumber';
import { useBox } from '../../Helper/useBox';
import { Grafica } from './Grafica';
import { GrupoScreen } from './GrupoScreen';
import { Consolidado } from './Tablas/Consolidado';
import { Region } from './Tablas/Region';
import { Sucursal } from './Tablas/Sucursal';
import { LoaderScreen } from "../../../components/LoaderScreen";
import PlantillaScreen from '../../../helpers/PlantillaScreen';
import { useHistory, useLocation } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { FiltroNivelInventario } from '../../Helper/FiltroNivelInventario';

export const NivelInventarioScreen = () => {
    const [boxstate, setBoxState] = useBox();
    const location = useLocation();
    const permisos = location.state;
    const idSucursalUnicos = [
    ...new Map(permisos.map(item => [item.idsucursal, { idsucursal: item.idsucursal }])).values()
    ];
    const storedState = JSON.parse(localStorage.getItem('dashboard_filtro')) || {};
    const [titulo, setTitulo] = useState('NIVEL DE INVENTARIO');
    const history = useHistory();
    const onHome = () => {
        history.push("/Finanzas/Main")
    };
    const [state, setState] = useState({
        data: [],
        mesinicio: boxstate.ejercicioinicio,
        ejercicio: boxstate.periodofin,
        subtitulo: '',
        activo: 'C',
        sucursales: '',
        adr: ''
    });
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    useEffect(() => {
        boxstate.mesInicio = storedState.periodofin
        boxstate.ejercicio = storedState.ejercicio
        // console.log(boxstate)
        BoxClick();
    }, []);

    // console.log(boxstate)


    const BoxClick = () => {
        return new Promise((res, req) => {
            if (boxstate.ejercicio == '0') {
                req("Favor de indicar el ejercicio");
                return;
            }
            if (boxstate.mesInicio == '0') {
                req("Favor de indicar el periodo");
                return;
            }
            const vm = {
                ejercicio: Number(boxstate.ejercicio || boxstate.ejercicioinicio),
                periodo: Number(boxstate.mesInicio || boxstate.periodofin),
                adr: GetKey(boxstate.pv.adr, ['idadr']),
                sucursal: GetKey(boxstate.pv.sucursal, ['idsucursal']) || GetKey(idSucursalUnicos, ["idsucursal"]),
                departamentos: GetKey(boxstate.pv.departamento, ['iddepartamento']),
                usuario: 0
            }
            setLoader({ ...loader, mostrar: true });
            request.post('FENivelInventario/Obtener', vm)
                .then(result => {
                    setLoader({ ...loader, mostrar: false });
                    setState({
                        ...state,
                        data: result,
                        mesinicio: boxstate.mesInicio,
                        ejercicio: boxstate.ejercicio,
                        sucursales: GetKey(boxstate.pv.sucursal, ['idsucursal']),
                        adr: GetKey(boxstate.pv.adr, ['idadr'])
                    });
                    res('')
                    setTitulo(
                        `NIVEL DE INVENTARIO ${GetMonthNameByNumber(boxstate.mesInicio || boxstate.periodofin).toUpperCase()} ${boxstate.ejercicio || boxstate.ejercicioinicio}`
                    );
                }).catch(err => {
                    setLoader({ ...loader, mostrar: false });
                    req(JSON.stringify(err));
                })
        })
    }
    const openModal = (reload = false) => {
        if (reload) {
            const element = document.getElementById('grafica-rotacion-inventario');
            if (element === undefined || element === null) return;
            reactDom.unmountComponentAtNode(element)
            reactDom.render(<Grafica
                mostrar={state.activo}
                data={state.data}
                ejercicio={state.ejercicio}
                mes={state.mesinicio}
            />, element)
        } else {
            // stratloading(true)
            // if (boxstate.ejercicio == '0') {
            //     changeloading('Favor de indicar el ejercicio', true);
            //     return;
            // }
            // if (boxstate.mesInicio == '0') {
            //     changeloading('Favor de indicar el periodo', true);
            //     return;
            // }
            // stratloading(false)

            const element = document.getElementById('grafica-rotacion-inventario');
            if (element === undefined || element === null) return;

            if (element.style.display === 'none')
                element.style.display = 'block'
            else
                element.style.display = 'none'

            reactDom.unmountComponentAtNode(element)
            reactDom.render(<Grafica
                mostrar={state.activo}
                data={state.data}
                ejercicio={state.ejercicio}
                mes={state.mesinicio}
            />, element)
        }
    }
    const getTitulo = () => {
        var titulo = '';
        switch (state.activo) {
            case 'S':
                titulo = `NIVEL DE INVENTARIOS POR SUCURSAL`;
                break;
            case 'R':
                titulo = `NIVEL DE INVENTARIOS POR ADR`;
                break;
            default:
                titulo = `NIVEL DE INVENTARIO CONSOLIDADO`;
                break;
        }
        return titulo
    }
    useEffect(() => {
        openModal(true)
    }, [state.activo])
    return (
        <PlantillaScreen
            titulo={titulo}
            className={"nivel-inventario-main-screen"}
            className_main={1}
        >
            <div id='rotacion-inventario' className='scroll-4'>
                <LoaderScreen loader={loader} />
                {/* <Loading lanzar={loading.lanzar} mensaje={loading.mensaje} error={loading.error} start={stratloading} /> */}
                <div className="nivel-inventario-contenedor-filtros">
                    <div className='nivel-inventario-regresar'
                        onClick={() => onHome()}
                    >
                        <ArrowBackIcon /> Regresar
                    </div>
                    <FiltroNivelInventario
                        onBoxChange={setBoxState}
                        boxState={boxstate}
                        BoxClick={BoxClick}
                        dmesfin="none"
                        sucursales={permisos}
                        titulo_filtro={'FILTRO'}
                        // titulo={getTitulo()}
                        // subtitulo={`${GetMonthNameByNumber(state.mesinicio)} del ${state.ejercicio}.`}
                        cargarDepartamento={false}
                        usuariodefault={1}
                    >
                        <div key='box-actions' id='rotacioninventario-acciones'>
                            <GrupoScreen state={state} setState={setState} />
                            <div className='button-excel' onClick={() => openModal()}>
                                Gráfica
                            </div>
                        </div>

                    </FiltroNivelInventario>
                </div>

                <div id='grafica-rotacion-inventario' style={{ display: 'none' }}></div>
                {state.data.length === 0 ? <div>Sin información para mostrar</div>

                    :
                    <div className='container-data scroll-4'>
                        {
                            state.activo === 'S'
                                ? <Sucursal data={state.data}
                                    mes={state.mesinicio}
                                    ejercicio={state.ejercicio}
                                />
                                : state.activo === 'R'
                                    ? <Region data={state.data}
                                        mes={state.mesinicio}
                                        ejercicio={state.ejercicio} />
                                    : <Consolidado data={state.data}
                                        mes={state.mesinicio}
                                        ejercicio={state.ejercicio}
                                    />
                        }

                    </div>
                }
            </div>
        </PlantillaScreen>
    )
}
